export default __webpack_public_path__ + "static/media/Collab6.043c3e61.png";